import type { DossierVu } from '../partage/api/types';
import { useSupprimerDossier } from '../partage/useArbre';
import { ceQuiPart } from './SupprimerBulle';
import { useEchap } from '../partage/useEchap';
import { GARDER_LE_PROJET, MOTS_ETAT, PROJET_PAS_SUPPRIME, SUPPRIMER_LE_PROJET } from '../partage/vocabulaire';
import './SupprimerDossier.css';

/**
 * La confirmation avant de supprimer un dossier (ticket 01 de finition-v1).
 *
 * Aucune planche ne dessine ce geste : il reprend la forme des autres dialogues (voile
 * clair et chaud, panneau posé au centre) et rien d'autre. Il sert à ce qui ne te concerne
 * pas, aux ERREURS et aux DOUBLONS ; une idée qu'on garde sans la faire se met « En
 * réflexion » (ticket 18 de retours-testeurs). Le dialogue le rappelle.
 *
 * Le geste principal est « garder » : c'est lui qui a le focus et la lueur. Supprimer
 * emporte tout le sous-arbre et ne se rattrape pas ; il ne doit jamais partir sur un Entrée
 * machinal. Pas de rouge non plus : on range une chose, on ne dramatise pas.
 */
export function SupprimerDossier({
  dossier,
  onFermer,
}: {
  dossier: DossierVu;
  onFermer: () => void;
}) {
  const supprimer = useSupprimerDossier();

  useEchap(true, onFermer, 'garde');

  function confirmer() {
    supprimer.mutate(dossier.id, { onSuccess: onFermer });
  }

  return (
    <>
      <div className="supprimer-voile" onClick={onFermer} aria-hidden="true" />

      {/* `data-dossier` : le tuto y retrouve le bouton de CE dossier (ticket 44). */}
      <div
        className="supprimer"
        data-tuto="supprimer"
        role="alertdialog"
        aria-label={`${SUPPRIMER_LE_PROJET} ${dossier.titre}`}
        data-dossier={dossier.id}
      >
        <h2>Supprimer «&nbsp;{dossier.titre}&nbsp;»&nbsp;?</h2>

        <p className="supprimer-emporte">{ceQuiPart(dossier.bulles, 'il')}</p>

        <p className="supprimer-impasse">
          Supprimer sert à ce qui ne te concerne pas, aux erreurs et aux doublons. Pour une
          idée que tu ne fais pas maintenant, garde-le et mets-le «&nbsp;{MOTS_ETAT.sans_objet}&nbsp;»
          : il ne compte pas dans ce qui reste à faire.
        </p>

        {supprimer.isError && (
          <p className="refus supprimer-refus">
            {PROJET_PAS_SUPPRIME}
          </p>
        )}

        <div className="supprimer-gestes">
          <button
            type="button"
            className="bouton bouton-discret supprimer-confirmer"
            data-tuto="supprimer-confirmer"
            onClick={confirmer}
            disabled={supprimer.isPending}
          >
            Supprimer
          </button>
          <button type="button" className="bouton" onClick={onFermer} autoFocus>
            {GARDER_LE_PROJET}
          </button>
        </div>
      </div>
    </>
  );
}
